import { defineMessages } from 'react-intl';

export default defineMessages({
  errorSubHeading: {
    id: 'errorBoundary.subHeading',
    defaultMessage: 'Something went wrong!',
  },
  errorDisplayText: {
    id: 'errorBoundary.displayText',
    defaultMessage: 'We are sorry, things did not go as planned! Please try again.',
  },
});
